__turbopack_context__.v({
  "label": "AreaGraph-module-scss-module__Mq7BSa__label",
  "output": "AreaGraph-module-scss-module__Mq7BSa__output",
});
